import { render, staticRenderFns } from "./testseahourse.vue?vue&type=template&id=8a6d8ad4&"
import script from "./testseahourse.vue?vue&type=script&lang=js&"
export * from "./testseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports